/* Core & libraries */

/* Helpers, constants, custom methods, internal libraries */
import { useGenericApiFetch }  from "../endpoints/base";
import {
  ADMIN_GET_MAINTENANCE_MODE,
  ADMIN_POST_MAINTENANCE_TOOGLE,
} from "../endpoints/endpoints";
import {FormattedMessage} from "react-intl";
import {roles} from "../constants/appConstants";
import React from "react";
import {useNotificationContext} from "../contexts/notificationContext";
import { useUserContext } from "../contexts/userContext";

/* Components */
/* Styles */

export const useSettingsService = () => {
  const { genericApiFetch } = useGenericApiFetch();
  const { setNotification } = useNotificationContext();

  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  const getMaintenanceMode = async () => {
    const response = await genericApiFetch({
      url: ADMIN_GET_MAINTENANCE_MODE.replace("{providerCode}", providerCode?.toLowerCase()),
      method: "GET",
      spinner: "getMaintenanceSpinner"
    });

    if (response.success) {
      return response.data;
    }
    return false;
  }

  const postMintenanceData = async (maintenanceData) => {
    const response = await genericApiFetch({
      url: ADMIN_POST_MAINTENANCE_TOOGLE.replace("{providerCode}", providerCode?.toLowerCase()),
      method: "POST",
      data : maintenanceData,
      spinner: "maintenanceDataSpinner"
    });
    if (response.success) {
      maintenanceData.maintenanceMode &&
        setNotification(
          "success",
          <FormattedMessage id="adminMaintenance.succesTitle" />,
          <FormattedMessage id="adminMaintenance.succesMessage"/>
        )
      return true
    }
    return false
  };

  return {
    getMaintenanceMode,
    postMintenanceData
  };
}

